<template lang="pug">
  .fpui-tabs
    ul.fpui-tabs-heads
      li.fpui-tabs-head(
        v-for="(tab, index) in tabs"
        v-if='!tab.hide'
        :class="{ active: index === active, disabled: tab.disabled }"
        @click="setActive(index)"
      )
        span(v-html='tab.header')
      li.fpui-tabs-head(
        v-if='actions'
        v-for='action, idx in actions'
      )
        span(v-html='action.label', @click='action.click')
    .fpui-tabs-contents
      slot
</template>

<script>
  export default {
    props: {
      defaultActive: { type: Number },
      actions: { type: Array }
    },
    data () {
      let active = this.defaultActive || 0
      return {
        active,
        tabs: []
      }
    },
    created () { this.tabs = this.$children },
    mounted () {
      if (this.tabs && this.tabs[this.active]) {
        this.tabs[this.active].active = true
      }
    },
    methods: {
      setActive (index) {
        let tab = this.tabs[index]
        if (tab.disabled) return
        this.active = index
        this.tabs.forEach((tab, idx) => {
          tab.active = index === idx
        })
        this.$emit('change', { tab: this.activeTab, active: this.active })
      }
    },
    computed: {
      activeTab () {
        return this.tabs[this.active]
      }
    }
  }
</script>

<style lang="less">
@import "~@/shared/styles/_variables.less";

.fpui-tabs {
  .fpui-tabs-title{
    text-transform: uppercase;
    position: absolute;
    padding: 0;
    line-height: 40px;
    overflow: hidden;
  }
  .fpui-tabs-contents {
    .fpui-tab-content {
      padding:10px;
    }
  }
	.fpui-tabs-heads {
    border-bottom: 3px solid #eee;
    padding: 0;
    margin: 0;
    width: 100%;
    overflow-y: hidden;
    height: 43px;
    overflow-x: auto;
    white-space: nowrap;
    &.right{
      text-align: right;
    }
    &.left{
      text-align: left;
    }
		.fpui-tabs-head {
      overflow: hidden;
      vertical-align: top;
      text-transform: uppercase;
      text-decoration: none;
      position: relative;
      padding: 0 10px;
      line-height: 40px;
      display: inline-block;
      cursor: pointer;
			&:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0%;
        border-bottom: 3px solid #10b6e9;
        transition: 0.5s;
        color: #10b6e9
			}

      &:hover,&.active{
        color: #10b6e9;
        &:after {
          border-bottom: 3px solid @blue;
          width: 100%;
        }
      }
      &.disabled {
        color: @grey;
        cursor: not-allowed;
        &:after {
          border-bottom: none;
          width: 100%;
        }
      }
		}
	}
}

</style>
